import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './GroupElement.css';
import Star from '../ui/Stars';
import { formatTypeIcon } from '../functions/functions';
import { useTranslation } from 'react-i18next';
import { urls } from '../router/urls';

const GroupElement = ({
  id,
  stars,
  taxon,
  descripcion,
  nombre,
  format,
  is_group,
  img,
  structured_group_data
}) => {
  useEffect(() => {}, []);
  const { t } = useTranslation();

  return (
    <div className="row options">
      <div className="col-md-3 mb-3">
        <Link
          to={
            is_group ? `/${urls.agrupaciones}/${id}` : `/${urls.recursos}/${id}`
          }
          title={nombre}
        >
          <img
            style={{ width: '100%' }}
            src={img || process.env.PUBLIC_URL + '/img/recursos.png'}
            alt="logo"
            aria-roledescription="logo"
          />
        </Link>
      </div>

      <div className="col-md-8">
        <Link
          to={
            is_group ? `/${urls.agrupaciones}/${id}` : `/${urls.recursos}/${id}`
          }
          title={nombre}
        >
          <h5 className="link-group-pwa">{nombre}</h5>
        </Link>

        <p className="resource-info-pwa">
          {formatTypeIcon(format) ? (
            <i className={formatTypeIcon(format).icon + ' text-blue'}> </i>
          ) : (
            ''
          )}
          <span className="mx-2">
            {' '}
            {formatTypeIcon(format)
              ? t(formatTypeIcon(format).label) + ' | '
              : ''}
            {t('calificacion')}
          </span>
          <Star rating={stars} /> {stars}
          {'.0'}
        </p>
        <p className="object-description ff-ws mt-3">{descripcion}</p>
        {is_group === null ? (
          <Link
            to={`/${urls.agrupaciones}/${structured_group_data['id']}`}
            title={t('agregacion')}
          >
            <img
              className="mt-1 mr-2"
              src={structured_group_data['technical_image']}
              height="23"
              alt="Icon"
            />
            <span className={'fs-md blue-MEN mt-1'}>
              {'| '}
              {structured_group_data['title']}
              <i className={'fal fa-angle-right ml-1'}></i>
            </span>
          </Link>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default GroupElement;
